import {IncomingContractorsBodyApp} from "../Functionality/IncomingContractorsBodyApp";
import CustomCardContainer from "../../../../../components/CustomCardContainer";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {
    IconChipDot,
    IconChipTools, IconChronometer, IconEmployeeFactory, IconEntryDevice, IconGuardTitle,
    IconInfoCard, PersonOutlinedChip,
} from "../../../../../components/buttons/IconButtons";
import CustomCard from "../../../../../components/CustomCard";
import {
    DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, formatTimeUnit,
    getDateFormat
} from "../../../../../Apis/functions";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import React from "react";
import {CARDS_MODEL} from "../Model/Model";
import { colors } from '../../../../../enums/colors';
import {CustomMinimap} from "../../../../../components/MiniMap/CustomMinimap";
import CustomExpandableTable from "../../../../../components/table/CustomExpandableTable";
import TimerChip from "./TimerChip";
import CustomChip from "../../../../../components/CustomChip";
import {MATERIAL_TYPE} from "../../../Contractors/EquipmentAndMaterial/Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 26 de noviembre de 2025
 */

const IncomingContractorsBody = ({
                                     t,
                                     withSearchActiveContractors,
                                     withSearchEmployeeInside,
                                     withSearchEmployeeOutside,
                                     withSearchEquipmentInside,
                                     withSearchEquipmentOutside,
                                     setShowCheckInModal,
                                     setShowCheckOutModal,
                                     setShowLogModal,
                                     setItemSelected,
                                     setOutLog
                                 }) => {


    const {
        handleRowExpand,
        expandableColumns,
        renderExpandedRow,
        wrapperRef,
        scrollerRef,
        activeContractorsColumn,
        otherColumns
    } = IncomingContractorsBodyApp(
        {
            withSearchActiveContractors,
            withSearchEmployeeInside,
            withSearchEmployeeOutside,
            withSearchEquipmentInside,
            withSearchEquipmentOutside,
            setShowCheckInModal,
            setShowCheckOutModal,
            setShowLogModal,
            setItemSelected,
            setOutLog
        }
    );

    return (
        <div id="div_icb_container_active" ref={wrapperRef}
            className="row flex-row flex-nowrap background-general-00 overflow-hidden
                       border-full-shades-300 pl-16px py-12px border-radius-8px"
        >
            { activeContractorsColumn && (
                    <div id={`col_${activeContractorsColumn.key}`} key={activeContractorsColumn.key} className={`p-0 col-3 w-100 minw-315px`}>
                        <CustomCardContainer cardContentClass={'h-60vh background-general-00 p-0 m-0'}>
                            <div className={"d-flex w-100"}>
                                <CustomGenericTittleIconDataChip title={activeContractorsColumn.title} border={false}/>
                            </div>
                            <p className={"font-color-primary-700 fs-14px ibl-font-w-400"}>
                                {activeContractorsColumn.items.length +" "+ t('contractors')}
                            </p>

                            <div className={"my-2 border-bottom-shades-300"}/>
                            {/**Done*/}
                            <CustomExpandableTable
                                columns={expandableColumns}
                                rows={activeContractorsColumn.items || []}
                                renderExpandedRow={renderExpandedRow}
                                onRowExpand={handleRowExpand}
                                checkbox={false}
                                showHeader={false}
                                classNameRenderContainer={"p-0"}
                                tooltip={true}
                                withoutHeight={true}
                            />
                        </CustomCardContainer>
                    </div>
                )
            }
           <div className={"col-9"}>
               <div id="div_icb_container" ref={scrollerRef}
                    className="row flex-row flex-nowrap background-general-00 overflow-auto
                            border-full-shades-300 ml-4 border-radius-8px pt-12px px-0">
                   {otherColumns?.map(column => (
                       <div id={`col_${column.key}`} key={column.key} className={`col-3 w-100 minw-510px`}>
                           {
                               <CustomCardContainer cardContentClass={'h-72vh border-radius-12px background-shades-100'}>
                                   <div className={"d-flex w-100 mb-2"}>
                                       <p className={"d-flex w-100 gap-1"}>
                                           <CustomGenericTittleIconDataChip Icon={column.icon} title={column.title} border={false}/>
                                           <div className={"d-flex background-shades-200 border-full-shades-300 rounded-circle w-15px h-18px justify-content-center align-items-center"}>
                                               <span className={"fs-12px ibl-font-w-500 font-color-shades-500"}>{column.items.length}</span>
                                           </div>
                                       </p>
                                       <CustomTooltip text={t(column.tooltip)}>
                                           <IconInfoCard className={"icon-color-shades-500"} width={20} height={20} />
                                       </CustomTooltip>
                                   </div>
                                   {column.items.map(item => {
                                       return (
                                           <CustomCard key={item.id} classes={'mt-3 mb-3'}
                                                       classCard={`card-border-8px p-16px`}
                                                       classContent={`p-0 background-general-00`}
                                           >
                                               <div className={"row gap-3"}>
                                                   {
                                                       column.key === CARDS_MODEL.EMPLOYEE_INSIDE &&
                                                       <div className={"p-0 m-0"}>
                                                           <div className={"d-flex align-items-center justify-content-between"}>
                                                               <div className={"d-flex align-items-center gap-2 p-0 m-0"}>
                                                                   <TimerChip date={item?.entryDate} />
                                                               </div>
                                                           </div>
                                                       </div>
                                                   }

                                                   <div className={"p-0 m-0 row col-12 justify-content-between"}>
                                                       {(column.key === CARDS_MODEL.EMPLOYEE_INSIDE ||
                                                           column.key === CARDS_MODEL.EMPLOYEE_OUTSIDE) && (
                                                           <div
                                                               className={`p-0 m-0 col-2 d-flex justify-content-center align-items-center maxw-44px maxh-44px
                                                                        ${column.key === CARDS_MODEL.EMPLOYEE_INSIDE ? 'background-primary-100' : 'background-shades-100'}
                                                                        p-8px border-radius-4px`}
                                                           >
                                                               <PersonOutlinedChip className="w-h-24px" />
                                                           </div>
                                                       )}
                                                       { [CARDS_MODEL.EQUIPMENT_INSIDE, CARDS_MODEL.EQUIPMENT_OUTSIDE].includes(column.key) &&
                                                       <div className={`p-0 m-0 col-2 d-flex justify-content-center align-items-center maxw-44px maxh-44px
                                                             ${column.key === CARDS_MODEL.EQUIPMENT_INSIDE ? 'background-warning-100' : 'background-shades-100'}  p-8px border-radius-4px`}>
                                                           <IconChipTools className={"w-h-24px"}/>
                                                       </div>
                                                       }
                                                       <div className={"p-0 m-0 col-10 d-flex flex-column justify-content-start gap-1"}>
                                                           <div className={"flex-row gap-2"}>
                                                               <CustomTooltip
                                                                   text={[CARDS_MODEL.EQUIPMENT_INSIDE, CARDS_MODEL.EQUIPMENT_OUTSIDE].includes(column.key) ? item?.name : item?.userFullName}
                                                                   classes={"text-capitalize font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                                                   showIfTruncated={true}
                                                               />
                                                               { column.key === CARDS_MODEL.EQUIPMENT_INSIDE && item?.exitDate == null &&
                                                               <>
                                                                   {" | "}
                                                                   <CustomChip
                                                                       background={colors.secondary100}
                                                                       borderColor={colors.secondary150}
                                                                       fontColor={colors.secondary700}
                                                                       legend={t(MATERIAL_TYPE[item?.owner]?.trans) || EMPTY_VALUES.DEFAULT}
                                                                       variant={'large'}
                                                                   />
                                                               </>
                                                               }
                                                           </div>
                                                           <p className={"text-capitalize font-color-general-950 ibl-font-w-400 fs-14px mb-2"}>
                                                               {
                                                                   [CARDS_MODEL.EQUIPMENT_INSIDE, CARDS_MODEL.EQUIPMENT_OUTSIDE].includes(column.key) ? (
                                                                       <>
                                                                           <div className={"d-flex"}>
                                                                               <div className={" minw-0"}>
                                                                                   <CustomTooltip
                                                                                       text={item?.code}
                                                                                       classes={"text-ellipsis-1-row"}
                                                                                       showIfTruncated={true}
                                                                                   />
                                                                               </div>
                                                                               <div className={"mx-2"}><IconChipDot /></div>
                                                                               <div className={"flex-grow-1 minw-0"}>
                                                                                   <CustomTooltip
                                                                                       text={item?.companyName}
                                                                                       classes={"text-ellipsis-1-row"}
                                                                                       showIfTruncated={true}
                                                                                   />
                                                                               </div>
                                                                           </div>
                                                                       </>
                                                                   ) : (
                                                                       <CustomTooltip
                                                                           text={ item?.companyName}
                                                                           classes={"text-ellipsis-1-row"}
                                                                           showIfTruncated={true}
                                                                       />
                                                                   )
                                                               }

                                                           </p>
                                                           <p className={"text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center gap-2 "}>
                                                               <IconEntryDevice className={"icon-color-shades-500 w-16px h-16px"} />
                                                               { [CARDS_MODEL.EMPLOYEE_INSIDE, CARDS_MODEL.EQUIPMENT_INSIDE].includes(column.key) ?
                                                                   <>
                                                                       { t("entry") + ": " +
                                                                       getDateFormat(
                                                                           item?.entryDate,
                                                                           false,
                                                                           DATE_TIME_FORMAT_NAME_MODEL.shortMonthWithTime12
                                                                       )}
                                                                   </>
                                                                   :
                                                                   <>
                                                                       { t("exit") + ": " +
                                                                       getDateFormat(
                                                                           item?.exitDate,
                                                                           false,
                                                                           DATE_TIME_FORMAT_NAME_MODEL.shortMonthWithTime12
                                                                       )}
                                                                   </>
                                                               }
                                                           </p>
                                                           { [CARDS_MODEL.EQUIPMENT_INSIDE, CARDS_MODEL.EQUIPMENT_OUTSIDE].includes(column.key) &&
                                                           <div className={"d-flex gap-2"}>
                                                               <div>
                                                                   <IconEmployeeFactory className={"icon-color-shades-500 w-16px h-16px"} />
                                                               </div>
                                                               <p className={"ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center"}>
                                                                   {t("linked_to")+ ": "}
                                                               </p>
                                                               <div className={"flex-grow-1 minw-0"}>
                                                                   <CustomTooltip
                                                                       text={item?.userFullName}
                                                                       classes={"text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px text-ellipsis-1-row"}
                                                                       showIfTruncated={true}
                                                                   />
                                                               </div>
                                                           </div>
                                                           }
                                                           <div className={"d-flex align-items-baseline gap-2"}>
                                                               <div>
                                                                   <IconGuardTitle className={"icon-color-shades-500 w-16px h-16px"} />
                                                               </div>
                                                               <p className={"ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center"}>
                                                                   {t("guard")+ ": "}
                                                               </p>
                                                               <div className={"flex-grow-1 minw-0"}>
                                                                   <CustomTooltip
                                                                       text={item?.guardFullName}
                                                                       classes={"text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px text-ellipsis-1-row"}
                                                                       showIfTruncated={true}
                                                                   />
                                                               </div>
                                                           </div>

                                                           {
                                                               column.key === CARDS_MODEL.EMPLOYEE_OUTSIDE &&
                                                               <p className={"ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center gap-2"}>
                                                                   <IconChronometer className={"icon-color-shades-500 w-16px h-16px"} />
                                                                   {t("total_time")+ " - " + formatTimeUnit(item?.totalTime)}
                                                               </p>
                                                           }
                                                       </div>
                                                   </div>
                                                   <>
                                                       {(column.key === CARDS_MODEL.EMPLOYEE_INSIDE) && (
                                                           <div className={"row"}>
                                                               <div className="col-6">
                                                                   <ButtonAction
                                                                       id={`btn_icb_${column.leftButton}`}
                                                                       name={ column.leftButton }
                                                                       className="btn-outlined-secondary-600-00 w-100"
                                                                       splitName={false}
                                                                       onClick={() => {
                                                                           setItemSelected(item)
                                                                           column?.leftButtonAction?.()
                                                                       }}
                                                                   />
                                                               </div>
                                                               {
                                                                   column?.rightButton &&
                                                                   <div className="col-6">
                                                                       <ButtonAction
                                                                           id={`btn_icb_${column.rightButton}`}
                                                                           name={column.rightButton}
                                                                           className="btn-icon-export w-100"
                                                                           splitName={false}
                                                                           onClick={() => {
                                                                               setItemSelected(item)
                                                                               column?.rightButtonAction?.()
                                                                           }}
                                                                       />
                                                                   </div>
                                                               }
                                                           </div>
                                                       )}
                                                       { (column.key === CARDS_MODEL.EMPLOYEE_OUTSIDE) && (
                                                           <div className="p-0 m-0 col-12 d-flex justify-content-center w-100">
                                                               <ButtonAction
                                                                   id="btn_icb_pending_to_complete"
                                                                   name={ column?.button }
                                                                   className="btn-outlined-secondary-600-00 w-100"
                                                                   splitName={false}
                                                                   onClick={() => {
                                                                       setItemSelected(item)
                                                                       column?.buttonAction?.()
                                                                   }}
                                                               />
                                                           </div>
                                                       )}
                                                   </>
                                               </div>
                                           </CustomCard>
                                       )
                                   })}
                               </CustomCardContainer>
                           }
                       </div>
                   ))}
               </div>
           </div>
            <div id="div_icb_container_minimap" className="minimap-main" >
                <CustomMinimap
                    targetRef={scrollerRef}
                    contentRef={wrapperRef}
                    height={72}
                    className="rounded-3"
                    contentSelector=":scope > div"
                />
            </div>
        </div>
    );
};

export default IncomingContractorsBody
